export default __webpack_public_path__ + "static/media/youtube.81a30b6c.svg";